export enum AppEvent {
  Login,
  Register,
  Logout,
  LoadTicketPage, // GA wants it
  AddToCart,
  UpdateCart,
  InitiateCheckout, // Start paying, but only if the cart has a value greater than 0.00
  Purchase, // Purchase completed (even if it's for 0.00)
  ReservationTimedOut, // The reservation timed out (after 15 minutes it wasn't completed or updated)
}
